import { hasUncaughtExceptionCaptureCallback } from "process";
import { BlobType } from "shared/services/httpService";

// Different processing depending on if on ios device / non safari.  
// The file reader approach will work on all platforms how ever the file isn't named, downloads as (unkown.csv)
declare global {
    interface Window {
        MSStream: any;
    }
}

export const blobDownload = (file: BlobType | null): void =>
{

    if (file) {

        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

        if (iOS) {
            var reader = new FileReader();
            reader.onload = function (e)
            {
                window.location.href = reader.result as string;
            }
            if (isSafari) {
                var blob = new Blob([file.blob], { type: 'text/csv' })
                reader.readAsDataURL(blob);
            }
            else
                if (file.blob.size > 1048576)
                    throw new RangeError("File exceeds maximum size for non-safari browser on ios.  Please use Safari if you wish to download this file.");
                else
                    reader.readAsDataURL(file.blob)
            return;
        }

        var lnk = document.createElement("a");

        if (lnk) {
            var blob = new Blob([file.blob], { type: 'text/csv' })
            lnk.href = window.URL.createObjectURL(blob);
            lnk.setAttribute("download", file.fileName);
            lnk.click();
        }
    }

}